(() => {
  const SELECTOR = '[data-shefa-desktop-categories]';

  const closeMenu = (menu) => {
    if (!menu) return;
    menu.removeAttribute('open');
  };

  const resetGroups = (menu) => {
    if (!menu) return;

    menu.querySelectorAll('[data-shefa-category-toggle]').forEach((button) => {
      const group = button.closest('[data-shefa-category-group]');
      const content = group?.querySelector('[data-shefa-category-content]');
      const title = group?.querySelector('.shefa-category-group__title')?.textContent.trim() || 'categoría';

      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', `Expandir ${title}`);
      if (content) content.hidden = true;
    });
  };

  const initMenu = (menu) => {
    if (!menu || menu.dataset.shefaCategoriesReady === 'true') return;
    menu.dataset.shefaCategoriesReady = 'true';

    resetGroups(menu);

    menu.addEventListener('toggle', () => {
      if (menu.open) resetGroups(menu);
    });

    menu.querySelector('[data-shefa-categories-close]')?.addEventListener('click', () => closeMenu(menu));

    menu.querySelectorAll('[data-shefa-category-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const group = button.closest('[data-shefa-category-group]');
        const content = group?.querySelector('[data-shefa-category-content]');
        if (!content) return;

        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.setAttribute('aria-label', `${expanded ? 'Expandir' : 'Contraer'} ${group.querySelector('.shefa-category-group__title')?.textContent.trim() || 'categoría'}`);
        content.hidden = expanded;
      });
    });

    menu.querySelectorAll('.shefa-category-group a').forEach((link) => {
      link.addEventListener('click', () => closeMenu(menu));
    });
  };

  const initAll = () => document.querySelectorAll(SELECTOR).forEach(initMenu);

  document.addEventListener('click', (event) => {
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((menu) => {
      if (!menu.contains(event.target)) closeMenu(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((menu) => {
      closeMenu(menu);
      menu.querySelector('summary')?.focus();
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) return;
    document.querySelectorAll(`${SELECTOR}[open]`).forEach(closeMenu);
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
